export default __webpack_public_path__ + "static/media/undraw_no_data_qbuo.f96fd671.svg";